import React from 'react';

import styles from '../Modal.module.scss';

export const DeleteFromCartModal = () => {
  const { txt } = styles;

  return <p className={txt}>Товар успешно удалён из корзины!</p>;
};
